import React from 'react';
import '../index.css';
import '../pubic/output.css';

import { useState, useEffect } from 'react';

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < breakpoint);
    checkMobile(); // Check on mount

    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, [breakpoint]);

  return isMobile;
}

export default function Announcement(){

  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <h1 className="font-bold text-center" style={{fontSize: "35px", objectFit: "contain", justifyContent: "center"}}>We're building the open market for ticketing.</h1>
    )} else {
  return(
    <h1 className="font-bold text-center" style={{fontSize: "70px", objectFit: "contain", justifyContent: "center"}}>We're building the open market for ticketing.</h1>
  )
}
}
